/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements/Requirements/Requirement/Info/RequiredTreatmentFields/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let txCardFieldsValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_fields',
})
let requirementIsRequiredValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'is_required',
})
let aggregateData = fromHelpers.getDescription(txCardFieldsValueData, requirementIsRequiredValueData)
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Missing required treatment fields:"
 size="xmedium"
 weight="semibold"
 marginRight={dtSpaceXs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx_card_fields"
 data="requirement.is_required"
 aggregate="./helpers.js getDescription"
 text={aggregateData}
 size="xmedium"
/>
</div>
{children}
</React.Fragment>)
}